// import React, { useState, useEffect, useContext } from "react";
// import { Col } from "react-bootstrap";
// import Slider from "react-slick";
// import "./HomeBanner.css";
// import URLstateContext from "../../../provider/CommonContext";
// import {
//   GetMethodData,
//   DecryptAESdata,
// } from "../../../provider/ServiceProvider";
// import animation from '../../../images/jm-animation.gif';
// function HomeBanner() {
//   const [Fetchdata, getData] = useState("");
//   const { BaseURL } = useContext(URLstateContext);
//   const [loadingshow, setloadingshow] = useState(false);
//   const settings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     arrows: false,
//     autoplay: true,
//     autoplaySpeed: 5000,
//   };
//   useEffect(() => {
//     // console.log(BaseURL);
//     setloadingshow(true);
//     GetMethodData(BaseURL + "GetBanner").then((data) => {
//       setloadingshow(false);
//       if (data.data != null && data.data.length > 0) {
//         getData(DecryptAESdata(data.data));
//         setloadingshow(false);
//         // console.log(DecryptAESdata(data.data));
//       }
//     });
//   }, [BaseURL]);
//   return (
//     <>
//       {/* <Col lg={12}> */}
//       <div className="parentslide">
//         {loadingshow ? (
//           <div className="textcentervertex">
//             <img src={animation} alt="Loading" />
//             <div className="model_popup">Please Wait...</div>
//           </div>
//         ) : (
//           <div>
//             {Fetchdata && Fetchdata.length === 0 ? (
//               <h5 className="errormsgComNew">No Data Available</h5>
//             ) : (
//               <>
//                 <Slider {...settings}>

//                   {/* {(Fetchdata.length === 0) ? <h5 className="errormsgComNew">No Data Available</h5> : ''} */}
//                   {Fetchdata &&
//                     Fetchdata.map(({ imgfilename, caption, bannerlink, investlink }, index) => (
//                       <div className="w-100">
//                         {bannerlink != null ? (
//                           <a target="_blank" rel="noreferrer" href={bannerlink}>
//                             <img
//                               alt={imgfilename}
//                               src={imgfilename}
//                               className="img-fluid mx-auto d-block"
//                             />
//                           </a>
//                         ) : (
//                           <img
//                             alt={imgfilename}
//                             src={imgfilename}
//                             className="img-fluid mx-auto"
//                           />
//                         )}
//                       </div>
//                     ))}
//                 </Slider>
//               </>
//             )}
//           </div>
//         )}
//       </div>
//       {/* {loadingshow ? <div className="textcentervertex">

//         <img src={animation} alt="Loading" />
//         <div className="model_popup">Please Wait...</div>
//       </div> : ""
//       } */}
//       {/* </Col> */}
//     </>
//   );
// }

// export default HomeBanner;

import React, { useState, useEffect, useContext, useRef } from "react";
import Slider from "react-slick";
import URLstateContext from "../../../provider/CommonContext";
import {
  GetMethodData,
  DecryptAESdata,
} from "../../../provider/ServiceProvider";
import animation from "../../../images/jm-animation.gif";
import "./HomeBanner.css";

function HomeBanner() {
  const [Fetchdata, getData] = useState("");
  const { BaseURL } = useContext(URLstateContext);
  const [loadingshow, setloadingshow] = useState(false);
  const [autoplay, setAutoplay] = useState(true);
  const sliderRef = useRef(null);


  const fixSliderAccessibility = () => {
  const hiddenSlides = document.querySelectorAll(
    ".slick-slide[aria-hidden='true'] a"
  );

  hiddenSlides.forEach((el) => {
    el.setAttribute("tabindex", "-1");
  });

  const visibleSlides = document.querySelectorAll(
    ".slick-slide[aria-hidden='false'] a"
  );

  visibleSlides.forEach((el) => {
    el.removeAttribute("tabindex");
  });
};

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: autoplay,
    autoplaySpeed: 15000,
    beforeChange: (current, next) => {
      if (next === Fetchdata?.length - 1) {
        setAutoplay(true);
      }
    },
    afterChange: (current) => {
        fixSliderAccessibility(); 
      if (current === 0 && !autoplay) {
        setAutoplay(true);
        if (sliderRef.current) {
          sliderRef.current.slickPlay(); // Manually trigger the autoplay
        }
      }
    },
  };

  useEffect(() => {
  setTimeout(() => {
    fixSliderAccessibility();
  }, 300);
}, [Fetchdata]);

  useEffect(() => {
    setloadingshow(true);
    GetMethodData(BaseURL + "GetBanner").then((data) => {
      setloadingshow(false);
      if (data.data != null && data.data.length > 0) {
        getData(DecryptAESdata(data.data));
      }
    });
  }, [BaseURL]);

  useEffect(() => {
    if (sliderRef.current && autoplay) {
      sliderRef.current.slickPlay();
    }
  }, [autoplay]);

  return (
    <>
      <div className="parentslide">
        {loadingshow ? (
          <div className="textcentervertex">
            <img src={animation} alt="Loading" />
            <div className="model_popup">Please Wait...</div>
          </div>
        ) : (
          <div>
            {Fetchdata && Fetchdata.length === 0 ? (
              <h5 className="errormsgComNew">No Data Available</h5>
            ) : (
              <Slider ref={sliderRef} {...settings}>
                {Fetchdata &&
                  Fetchdata.map(({ imgfilename, bannerlink }, index) => (
                    <div className="w-100" key={index}>
                      {bannerlink != null ? (
                        <a target="_blank" rel="noreferrer" href={bannerlink}>
                          <img
                            alt={imgfilename}
                            src={imgfilename}
                            className="img-fluid mx-auto d-block"
                          />
                        </a>
                      ) : (
                        <img
                          alt={imgfilename}
                          src={imgfilename}
                          className="img-fluid mx-auto d-block"
                        />
                      )}
                    </div>
                  ))}
              </Slider>
            )}
          </div>
        )}
      </div>
    </>
  );
}

export default HomeBanner;
